import { useState, useEffect, useCallback } from 'react';
import fleetApi from '../../services/api.service';
import { buildUrlWithParams } from '../../utils/url.utils';

export default function useGetAddressConsignmentStock(addressId) {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(
    async (signal) => {
      if (!addressId) {
        setData(null);
        setError(null);
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setError(null);
      try {
        const url = buildUrlWithParams('/consignment/stock', {
          address_id: addressId,
        });
        const response = await fleetApi.get(url, { signal });
        const stocks = response.data?.data ?? [];
        const total_stock = stocks.reduce((sum, item) => sum + item.stock, 0);

        if (!signal?.aborted) {
          setData({ address_id: addressId, total_stock, stocks });
        }
      } catch (err) {
        if (!signal?.aborted) {
          setError(
            err.response?.data?.message ||
              err.message ||
              'Une erreur est survenue'
          );
        }
      } finally {
        if (!signal?.aborted) {
          setIsLoading(false);
        }
      }
    },
    [addressId]
  );

  useEffect(() => {
    const controller = new AbortController();
    fetchData(controller.signal);

    return () => {
      controller.abort();
    };
  }, [fetchData]);

  return { data, isLoading, error, mutate: fetchData };
}
